import MenuGalleryApp from '@vue/app/MenuGalleryApp.vue';
import { createApp } from 'vue';
await S.import('@main');
await u.domready();
const app = createApp(MenuGalleryApp, u.data('app.props'));
app.mount('#menu-gallery-app');
